export default __webpack_public_path__ + "static/media/GINO.e5ba5dc4.png";